import { useTheme } from '@emotion/react'
import React from 'react'
import Joyride, { CallBackProps, Step, TooltipRenderProps } from 'react-joyride'
import { joyrideLocales } from './locales'

interface IProps {
  steps: Step[]
  showSkipButton?: boolean
  disableScrolling?: boolean
  tooltipComponent: React.ElementType<TooltipRenderProps> | undefined
  onCallback: (data: CallBackProps) => void
}

const JoyrideDefault: React.FC<IProps> = ({
  steps,
  tooltipComponent,
  disableScrolling = false,
  showSkipButton = true,
  onCallback,
}) => {
  const theme = useTheme()
  return (
    <Joyride
      run={!!steps}
      debug={false}
      steps={steps}
      continuous={true}
      showSkipButton={showSkipButton}
      hideBackButton={true}
      disableScrolling={disableScrolling}
      tooltipComponent={tooltipComponent}
      scrollToFirstStep
      scrollOffset={300}
      scrollDuration={200}
      disableOverlayClose
      callback={onCallback}
      floaterProps={{
        styles: {
          floater: {
            zIndex: 1002,
          },
          floaterWithComponent: {
            whiteSpace: 'pre-wrap',
          },
        },
      }}
      styles={{
        options: {
          width: 'auto',
          spotlightShadow: 'box-shadow: 0 10px 20px 0 rgba(0,0,0,0.25);',
        },
        beacon: {
          height: '50px',
          width: '50px',
          marginTop: '-30px',
        },
        beaconInner: {
          backgroundColor: theme.primary,
          border: `2px solid ${theme.primary}`,
        },
        beaconOuter: {
          backgroundColor: theme.illustrationPrimary40,
          border: `2px solid ${theme.primary}`,
        },
        overlay: {
          zIndex: 1001,
        },
      }}
      locale={joyrideLocales}
    />
  )
}

export default JoyrideDefault
